/**
 * The one list of customer-contact roles.
 *
 * It lived as a private `CONTACT_ROLE_OPTIONS` inside CustomerDetail.tsx while
 * that was the only screen recording a role. NewJobScreen is the second, and a
 * closed vocabulary duplicated across screens is the shape CLAUDE.md warns
 * about under "Adding an enum value": each copy has to be found by someone who
 * knows it exists, and the copy that does not name the array is the one grep
 * misses. Extracted rather than copied, so there is one place to add to.
 *
 * FREE TEXT IN THE DATABASE — `customer_contacts.role` is `text`, with no CHECK
 * and no enum. These are the offered values, not the permitted ones, and rows
 * written by an import or by an older client may hold anything. Production held
 * exactly `Company Man` and `Other` on 2026-09-09, across 4 rows.
 *
 * NULL MEANS ELIGIBLE, NEVER ENDORSED. Nothing resolves on role today, and if
 * anything ever does it is a TIE-BREAK among candidates that are already
 * eligible, never a filter on the set — 49 of the estate's 49 rig-scoped
 * contacts carried no role when this was written, so treating blank as "not
 * endorsed" would refuse every rig in production. The API pins that in
 * `src/__tests__/contact-role-is-not-a-filter.test.ts`.
 */
export interface ContactRoleOption {
  value: string;
  label: string;
}

export const CONTACT_ROLE_OPTIONS: ContactRoleOption[] = [
  { value: '', label: 'Select role...' },
  { value: 'AP', label: 'AP' },
  { value: 'Company Man', label: 'Company Man' },
  { value: 'Dispatch', label: 'Dispatch' },
  { value: 'Other', label: 'Other' },
];
